import { render, staticRenderFns } from "./EditLevelView.vue?vue&type=template&id=455f05cc&scoped=true&"
import script from "./EditLevelView.vue?vue&type=script&lang=ts&"
export * from "./EditLevelView.vue?vue&type=script&lang=ts&"
import style0 from "./EditLevelView.vue?vue&type=style&index=0&id=455f05cc&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "455f05cc",
  null
  
)

export default component.exports